import React from 'react';
import Radio from '../assets/images/Radio.svg';

export default () => {
  return <img src={Radio} alt="" />;
};
